import { useWormhole } from "../../../../hooks/index.js";
import { useEditorData } from "../../context/index.js";
function useEditorQuickInsertToolbar() {
  const { quickInsertTarget } = useEditorData();
  const { worms: quickInsertItems } = useWormhole(quickInsertTarget);
  return { quickInsertItems };
}
export {
  useEditorQuickInsertToolbar
};
//# sourceMappingURL=useEditorQuickInsertToolbar.js.map
